import React from "react";
import { BrowserRouter as Router, Link as LinkDefault } from "react-router-dom";
import scrollTo from '../helpers/scroll-to';
import scrollUrl from '../helpers/scrollUrl';
import PopoverLogin from "./PopoverLogin";

const inRect = (id, scroll) => {
  const el = document.querySelector(id);
  return !!el && (scroll > el.offsetTop && scroll < (el.offsetTop + el.offsetHeight));
};

const Link = (props) => {
  return props.to && props.to.startsWith('http')
    ? <a {...props} href={props.to} />
    : <LinkDefault {...props} />
};

export default class Nav extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      bg: '',
      current: null,
      scroll: '',
      popover: false
    };
  };
  componentDidMount = () => {
    window.addEventListener("scroll", this._handleScroll);
  };

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this._handleScroll);
  };

  _handleScroll = (event) => {
    const isXs = (window.innerWidth <= 678) ? true : false;
    const isSm = (window.innerWidth >= 679 && window.innerWidth < 768) ? true : false;
    const isMd = (window.innerWidth >= 768 && window.innerWidth < 992) ? true : false;
    const isLg = (window.innerWidth >= 992 && window.innerWidth < 1310) ? true : false;

    let positionTheProgram = false;
    let positionHowWorks = false;
    let positionBenefits = false;
    let positionDownloadApp = false;

    const scroll = window.scrollY;

    if(scroll > 30){
      let offset = document.querySelector('.navbar').offsetHeight + 30;
      this.setState({bg: 'bg-white', scroll: 'scroll'});

      let topSection1 = inRect('#sustentabilidade-no-pao', scroll + offset);
      let topSection2 = inRect('#conceito', scroll + offset);
      let topSection3 = inRect('#nossas-iniciativas', scroll + offset);
      let topSection4 = inRect('#cadastre-se', scroll + offset);

      if(topSection1){
        this.setState({current: 0});
        scrollUrl("/sustentabilidade/sustentabilidade-no-pao");
      }else if(topSection2){
        this.setState({current: 1});
        scrollUrl("/sustentabilidade/conceito");
      }else if(topSection3){
        this.setState({current: 2});
        scrollUrl("/sustentabilidade/nossas-iniciativas");
      }else if(topSection4){
        this.setState({current: 3});
        scrollUrl("/sustentabilidade/cadastre-se");
      }else{
        this.setState({current: null});
        scrollUrl("/sustentabilidade");
      }
    }else{
      this.setState({bg: 'bg-transparent', scroll: '', current: null});
      scrollUrl("/sustentabilidade");
    }
  };

  _handleLinksTop = () => {
    return this.props.linksTop.map((link, i) => {
      return (
        <a key={i}
          onClick={link.desc === "Política de privacidade" ? this.props.actionsModal('open','POLITICAS') : ()=>{}}
          target={link.target}
          className={'scroll nav-item nav-link top pl-3 pr-3 text-white font-10 ' + (i === this.props.linksTop.length-1 ? 'bg-loyalty' : '')}
          href={link.href}>
            {link.desc}
        </a>
      )
    })
  };

  _handleLinks = () => {
    return this.props.links.map((link, i) => {
      return (
        <a key={i}
          href=""
          onClick={scrollTo(link.hash, link.top)}
          style={{
            position: link.class === 'optin' ? 'absolute' : '',
            right: link.class === 'optin' ? '0' : '',
            paddingRight: link.class === 'optin' ? '0' : '',
          }}
          className={'scroll nav-item nav-link text-black font-14 ' + (link.class === 'optin' ? 'mr-0 ' : 'mr-3 ') + (i === this.state.current ? 'active' : '')}>
            <span className={link.class}>{link.desc}</span>
            {i === this.state.current ? (<span key="current" className="sr-only">(current)</span>): ''}
        </a>
      )
    })
  };

  render() {
    return (
      <nav className={`navbar navbar-expand-lg navbar-light p-0 fixed-top ${this.state.bg} ${this.state.scroll}`} style={this.props.style}>
        <div className="collapse navbar-collapse bg-primary">
          <div className="navbar-nav position-absolute">
            {this._handleLinksTop()}
          </div>
        </div>
        <div className="container text-center">
          <Link to="/" onClick={scrollTo('#topo')} style={{display: 'block', margin: '0 auto'}}>
            <img className="navbar-brand" src={this.props.logo} />
          </Link>
          <div className="collapse navbar-collapse" style={{ position: 'relative' }}>
            {this._handleLinks()}
            {/* <div className="navbar-nav font-weight-bold">
              {this._handleLinks()}
              <a className={'login nav-item nav-link text-black font-14 mr-2 ml-3 btn font-weight-bold position-absolute text-right ' + (localStorage.logged ? 'logged' : '')} onClick={() => {this.setState({popover: !this.state.popover})}}>
                {localStorage.logged ? <i className="material-icons person bg-loyalty text-white text-center font-18">person</i> : ""} {localStorage.logged ? localStorage.username : 'Entre'}
              </a>
              <PopoverLogin className={this.state.popover ? (localStorage.logged ? "d-block popover-logged" : "d-block") : "d-none"} {...this.props}/>
              <a className={localStorage.logged ? "d-none" : "nav-item nav-link text-white font-14 btn btn-loyalty position-absolute"} href="/register?origin=mais">
                Cadastre-se
              </a>
            </div> */}
          </div>
          <button onClick={() => this.props.onMobile()} className={`border-0 p-0 d-lg-none d-xl-none bg-transparent mr-3 ${this.state.bg}`} type="button">
            <i className="material-icons text-loyalty font-30">menu</i>
          </button>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav.js